import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  DsButtonModule,
  DsFormFieldModule,
  DsFormsModule,
  DsLoadingAreaModule,
  DsMessageModule,
  DsCheckboxModule,
  DsRadioGroupModule,
  DsTableModule,
  DsModalModule,
  DsDatepickerModule,
  DsInputMaskModule,
  DsAccordionModule,
  DsBoxModule,
  DsBadgeModule,
  DsLinkModule,
} from '@bmw-ds/components';

import { CommonModule } from '@angular/common';

import { AllAuthorizedDriverFormGroup } from 'src/app/models/employee-driver-license-and-information.model';

@Component({
  selector: 'app-authorized-driver-section',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DsFormFieldModule,
    DsFormsModule,
    CommonModule,
    DsButtonModule,
    DsLoadingAreaModule,
    DsMessageModule,
    DsModalModule,
    DsCheckboxModule,
    DsRadioGroupModule,
    DsTableModule,
    DsModalModule,
    DsDatepickerModule,
    DsInputMaskModule,
    DsAccordionModule,
    DsBoxModule,
    DsBadgeModule,
    DsLinkModule,
  ],
  templateUrl: './authorized-driver-section.html',
  styleUrl: './authorized-driver-section.scss',
})
export class AuthorizedDriverSection {
  @Output() submitAuthorizedDriver = new EventEmitter<void>();
  @Output() emailConsentToAuthorizedDriver = new EventEmitter<void>();

  @Input() authorizedDriverForms!: AllAuthorizedDriverFormGroup;

  handleSubmit() {}

  handleDeleteAuthorizedDriver() {}
  handleReactivateAuthorizedDriver() {}

  handleSendConsentEmail() {}
  handleAddAuthorizedDriver() {}
}
